import * as SentryKit from '@looko-corp/acloset-react-kit/src/sentry';

/**
 * Acloset 디버그(Sentry alias 용).
 */
export const acDebug = SentryKit.acDebug;

/**
 * Acloset Info (Sentry alias 용).
 */
export const acInfo = SentryKit.acInfo;

/**
 * Acloset 경고(Sentry alias 용).
 */
export const acWarn = SentryKit.acWarn;

/**
 * Acloset 에러(Sentry alias 용).
 */
export const acError = SentryKit.acError;

/**
 * Acloset 크리티컬 에러(Sentry alias 용).
 */
export const acFatal = SentryKit.acFatal;

/**
 * Acloset 심각한 예외 보고.
 */
export const acCaptureError = SentryKit.acCaptureError;

/**
 * Acloset 심각한 예외 보고.
 */
export const acCaptureException = SentryKit.acCaptureException;
